import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=eb06b656&scoped=true&"
import script from "./DashboardPage.vue?vue&type=script&lang=js&"
export * from "./DashboardPage.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPage.vue?vue&type=style&index=0&id=eb06b656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb06b656",
  null
  
)

export default component.exports